export { default as ic_very_good } from "./emotion/ic_very_good.svg?react";
export { default as ic_good } from "./emotion/ic_good.svg?react";
export { default as ic_commonly } from "./emotion/ic_commonly.svg?react";
export { default as ic_poor } from "./emotion/ic_poor.svg?react";
export { default as ic_very_poor } from "./emotion/ic_very_poor.svg?react";
export { default as ic_write_move_arrow } from "./ic_write_move_arrow.svg?react";
export { default as ic_write_quit } from "./ic_write_quit.svg?react";
export { default as ic_essential_star } from "./ic_essential_star.svg?react";
